
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService} from '../modules/wino-shared/services/permission.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class AppInitializerService {

    constructor(private httpClient: HttpClient, private permissionService: PermissionService,
        private router: Router) { }

    public start(): Promise<boolean | void> {
        console.log("RUNTIME ENVIRONMENT: " + environment.env);
        return new Promise<boolean>( (resolve, reject) => {
            this.permissionService.retrievePermissions().then(result => {
                if (result) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        }).then( result => {
            console.log("Permissions retrieved? " + result);
        }).catch( (err) => {
            console.log("An error occurred retrieving permissions...");
            console.log(err.message);
        });
    }
}
